import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { IoCreateOutline, IoDocumentTextOutline, IoLockClosedOutline, IoCheckmarkCircle, IoBusinessOutline } from 'react-icons/io5';
import { doc, getDoc, setDoc, deleteDoc, collection, query, where, getDocs, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../../firebase/config';

const ADMIN_DEFAULT = {
  loginId: 'admin',
  password: 'admin1234',
  name: '조군',
  role: 'hq',
  status: 'approved',
  provider: 'email',
  phone: '010-6617-9912',
  phoneE164: '+821066179912',
  phoneVerified: true,
  companyName: '조군산업본사',
};

const NOTIFICATION_ITEMS = [
  { key: 'newUser', label: '새 회원 가입 요청', desc: '새로운 회원이 가입 신청하면 알림', targets: ['관리자'] },
  { key: 'userApproval', label: '회원 승인/거절 결과', desc: '가입 승인 또는 거절 시 본인에게 알림', targets: ['파트너(본인)'] },
  { key: 'newSchedule', label: '새 일정 등록', desc: '새로운 시공 일정이 등록되면 알림', targets: ['관리자', '파트너(해당)'] },
  { key: 'scheduleChange', label: '일정 변경/취소', desc: '시공 일정이 변경되거나 취소되면 알림', targets: ['관리자', '파트너(해당)'] },
  { key: 'newOrder', label: '새 주문 접수', desc: '새로운 자재 주문이 접수되면 알림', targets: ['관리자', '파트너(주문자)'] },
  { key: 'orderStatus', label: '주문 상태 변경', desc: '주문 상태가 변경되면 알림', targets: ['관리자', '파트너(주문자)'] },
  { key: 'newNotice', label: '새 공지사항 등록', desc: '새로운 공지사항이 등록되면 알림', targets: ['파트너(전체)'] },
  { key: 'newChat', label: '새 채팅 메시지', desc: '새로운 채팅 메시지가 오면 알림', targets: ['관리자', '파트너(상대방)'] },
];

const POLICY_TYPES = [
  { id: 'terms', label: '이용약관' },
  { id: 'privacy', label: '개인정보 처리방침' },
  { id: 'location', label: '위치기반 서비스 이용약관' },
];

const DEFAULT_POLICIES = {
  terms: `제1조 (목적)
본 약관은 (주)조군산업(이하 "회사")이 제공하는 렉스크리트 비즈니스 관리 서비스(이하 "서비스")의 이용에 관한 조건 및 절차, 회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.

제2조 (정의)
- "서비스"란 회사가 제공하는 일정 관리, 자재 주문, 업체 간 소통 등 업무 관리 플랫폼을 말합니다.
- "이용자"란 본 약관에 따라 서비스를 이용하는 회원을 말합니다.
- "회원"이란 서비스에 가입하여 회사가 승인한 자를 말합니다.

제3조 (약관의 효력 및 변경)
본 약관은 서비스를 이용하고자 하는 모든 이용자에게 적용됩니다. 회사는 필요한 경우 약관을 변경할 수 있으며, 변경 시 시행일 7일 전부터 서비스 내에서 공지합니다.

제4조 (회원 가입)
서비스 이용을 원하는 자는 회사가 정한 양식에 따라 회원 정보를 기입하고 본 약관에 동의한 후 가입 신청을 합니다. 회사는 심사 후 가입을 승인합니다.

제5조 (서비스 이용)
- 서비스는 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간 제공됩니다.
- 회사는 서비스 개선을 위해 사전 공지 후 일시적으로 서비스를 중단할 수 있습니다.

제6조 (이용자의 의무)
- 이용자는 타인의 정보를 도용하거나 허위 정보를 등록해서는 안 됩니다.
- 이용자는 서비스를 이용하여 법령 또는 공공질서에 위반되는 행위를 해서는 안 됩니다.
- 이용자는 자신의 계정 정보를 안전하게 관리할 책임이 있습니다.

제7조 (회사의 의무)
회사는 관련 법령과 본 약관이 금지하는 행위를 하지 않으며, 안정적인 서비스 제공을 위해 최선을 다합니다.

제8조 (면책)
회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우 책임이 면제됩니다.

부칙
본 약관은 2026년 2월 24일부터 시행합니다.`,

  privacy: `제1조 (목적)
(주)조군산업(이하 "회사")은 「개인정보 보호법」에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을 수립·공개합니다.

제2조 (수집하는 개인정보 항목)
회사는 서비스 제공을 위해 다음의 개인정보를 수집합니다.
- 필수항목: 이름, 연락처(휴대폰번호), 업체명, 대표자명, 아이디, 비밀번호
- 선택항목: 지역, 사업자등록번호, 이메일
- 자동수집: 서비스 이용기록, 접속 로그, 기기정보

제3조 (개인정보의 수집 및 이용 목적)
- 회원 가입 및 관리: 본인확인, 가입의사 확인, 서비스 부정이용 방지
- 서비스 제공: 일정 관리, 자재 주문, 업체 간 정보 공유
- 고충처리: 민원인 확인, 사실조사, 처리결과 통보

제4조 (개인정보의 보유 및 이용 기간)
회원 탈퇴 시까지 보유하며, 관련 법령에 따라 보존할 필요가 있는 경우 해당 기간 동안 보관합니다.
- 계약 또는 청약철회 등에 관한 기록: 5년
- 대금결제 및 재화 등의 공급에 관한 기록: 5년
- 소비자 불만 또는 분쟁처리에 관한 기록: 3년

제5조 (개인정보의 제3자 제공)
회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 이용자가 사전에 동의한 경우 또는 법령의 규정에 의한 경우는 예외로 합니다.

제6조 (개인정보의 파기)
회사는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.

제7조 (이용자의 권리)
이용자는 언제든지 자신의 개인정보를 조회하거나 수정할 수 있으며, 가입 해지(회원 탈퇴)를 요청할 수 있습니다.

제8조 (개인정보 보호 책임자)
성명: (주)조군산업 개인정보보호팀
연락처: 1544-5023

부칙
본 개인정보 처리방침은 2026년 2월 24일부터 시행합니다.`,

  location: `제1조 (목적)
본 약관은 (주)조군산업(이하 "회사")이 제공하는 위치기반 서비스에 대해 회사와 이용자 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.

제2조 (서비스 내용)
회사는 이용자의 위치정보를 이용하여 다음의 서비스를 제공합니다.
- 현장 위치 확인 및 지도 표시
- 일정 등록 시 주소 기반 위치 안내
- 가까운 현장 및 업체 탐색

제3조 (위치정보 수집)
회사는 서비스 제공을 위해 이용자의 동의하에 위치정보를 수집합니다. 수집하는 위치정보는 다음과 같습니다.
- GPS를 통한 현재 위치 좌표
- 이용자가 입력한 현장 주소 정보

제4조 (위치정보 이용 및 보유)
- 위치정보는 서비스 제공 목적으로만 이용됩니다.
- 위치정보는 서비스 이용 종료 시 즉시 파기합니다.
- 다만, 관련 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관할 수 있습니다.

제5조 (이용자의 권리)
이용자는 언제든지 위치정보 수집에 대한 동의를 철회할 수 있으며, 동의 철회 시 위치기반 서비스 이용이 제한될 수 있습니다.

제6조 (위치정보의 제3자 제공)
회사는 이용자의 사전 동의 없이 위치정보를 제3자에게 제공하지 않습니다. 다만, 법령에 의한 경우는 예외로 합니다.

제7조 (손해배상)
회사의 위치정보 관련 의무 위반으로 이용자에게 손해가 발생한 경우, 이용자는 회사에 손해배상을 청구할 수 있습니다.

부칙
본 약관은 2026년 2월 24일부터 시행합니다.`,
};

const AdminSettingsPage = () => {
  const [notifSettings, setNotifSettings] = useState(() => {
    const defaults = {};
    NOTIFICATION_ITEMS.forEach(n => { defaults[n.key] = true; });
    return defaults;
  });
  const [policies, setPolicies] = useState({});
  const [editingPolicy, setEditingPolicy] = useState(null);
  const [editContent, setEditContent] = useState('');
  const [saving, setSaving] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const [adminDocId, setAdminDocId] = useState(null);
  const [showPwModal, setShowPwModal] = useState(false);
  const [pwForm, setPwForm] = useState({ current: '', newPw: '', confirm: '' });
  const [pwError, setPwError] = useState('');
  const [pwSaving, setPwSaving] = useState(false);
  const [pwSuccess, setPwSuccess] = useState(false);
  const [companyInfo, setCompanyInfo] = useState({
    headerTitle: '조군산업',
    name: '(주)조군산업 JOGUN INDUSTRY',
    ceo: '조군',
    bizNo: '000-00-00000',
    address: '인천광역시 서구 가좌동 524-11',
    phone: '1544-5023',
  });
  const [companySaving, setCompanySaving] = useState(false);
  const [companySaved, setCompanySaved] = useState(false);

  useEffect(() => {
    loadPolicies();
    loadNotifSettings();
    loadAdminUser();
    loadCompanyInfo();
  }, []);

  const loadAdminUser = async () => {
    try {
      const q = query(collection(db, 'users'), where('loginId', '==', 'admin'));
      const snap = await getDocs(q);
      if (!snap.empty) {
        const d = snap.docs[0];
        const data = d.data();
        // 전화번호나 업체명 없으면 기존 문서 삭제 후 재생성
        if (!data.phoneE164 || !data.companyName) {
          await deleteDoc(doc(db, 'users', d.id));
          await setDoc(doc(collection(db, 'users')), {
            ...ADMIN_DEFAULT,
            createdAt: serverTimestamp(),
          });
          await loadAdminUser();
          return;
        }
        setAdminUser(data);
        setAdminDocId(d.id);
      } else {
        await setDoc(doc(collection(db, 'users')), {
          ...ADMIN_DEFAULT,
          createdAt: serverTimestamp(),
        });
        await loadAdminUser();
      }
    } catch (err) {
      console.error('관리자 계정 로드 실패:', err);
    }
  };

  const handlePwOpen = () => {
    setPwForm({ current: '', newPw: '', confirm: '' });
    setPwError('');
    setPwSuccess(false);
    setShowPwModal(true);
  };

  const handlePwSave = async () => {
    setPwError('');
    if (!pwForm.current || !pwForm.newPw || !pwForm.confirm) {
      setPwError('모든 항목을 입력해주세요.');
      return;
    }
    if (pwForm.current !== adminUser?.password) {
      setPwError('현재 비밀번호가 일치하지 않습니다.');
      return;
    }
    if (pwForm.newPw.length < 4) {
      setPwError('새 비밀번호는 4자 이상 입력해주세요.');
      return;
    }
    if (pwForm.newPw !== pwForm.confirm) {
      setPwError('새 비밀번호가 일치하지 않습니다.');
      return;
    }
    setPwSaving(true);
    try {
      await updateDoc(doc(db, 'users', adminDocId), { password: pwForm.newPw });
      setAdminUser(prev => ({ ...prev, password: pwForm.newPw }));
      setPwSuccess(true);
      setTimeout(() => setShowPwModal(false), 1500);
    } catch (err) {
      setPwError('비밀번호 변경에 실패했습니다.');
    } finally {
      setPwSaving(false);
    }
  };

  const loadCompanyInfo = async () => {
    try {
      const snap = await getDoc(doc(db, 'settings', 'companyInfo'));
      if (snap.exists()) setCompanyInfo(snap.data());
    } catch (err) {
      console.error('회사정보 로드 실패:', err);
    }
  };

  const saveCompanyInfo = async () => {
    setCompanySaving(true);
    try {
      await setDoc(doc(db, 'settings', 'companyInfo'), companyInfo);
      setCompanySaved(true);
      setTimeout(() => setCompanySaved(false), 2000);
    } catch (err) {
      console.error('회사정보 저장 실패:', err);
    } finally {
      setCompanySaving(false);
    }
  };

  const loadNotifSettings = async () => {
    try {
      const snap = await getDoc(doc(db, 'settings', 'notifications'));
      if (snap.exists()) {
        setNotifSettings(prev => ({ ...prev, ...snap.data() }));
      }
    } catch (err) {
      console.error('알림 설정 로드 실패:', err);
    }
  };

  const toggleNotification = async (key) => {
    const next = { ...notifSettings, [key]: !notifSettings[key] };
    setNotifSettings(next);
    try {
      await setDoc(doc(db, 'settings', 'notifications'), next);
    } catch (err) {
      console.error('알림 설정 저장 실패:', err);
      setNotifSettings(prev => ({ ...prev, [key]: !prev[key] }));
    }
  };

  const loadPolicies = async () => {
    const loaded = {};
    for (const p of POLICY_TYPES) {
      try {
        const snap = await getDoc(doc(db, 'policies', p.id));
        if (snap.exists()) {
          loaded[p.id] = snap.data();
        }
      } catch (err) {
        console.error(`약관 로드 실패 (${p.id}):`, err);
      }
    }
    setPolicies(loaded);
  };

  const handleInitPolicy = async (policyId) => {
    try {
      await setDoc(doc(db, 'policies', policyId), {
        content: DEFAULT_POLICIES[policyId],
        updatedAt: serverTimestamp(),
      });
      await loadPolicies();
    } catch (err) {
      console.error('약관 초기화 실패:', err);
    }
  };

  const handleEditOpen = (p) => {
    const content = policies[p.id]?.content || DEFAULT_POLICIES[p.id] || '';
    setEditContent(content);
    setEditingPolicy(p);
  };

  const handleSave = async () => {
    if (!editingPolicy) return;
    setSaving(true);
    try {
      await setDoc(doc(db, 'policies', editingPolicy.id), {
        content: editContent,
        updatedAt: serverTimestamp(),
      });
      await loadPolicies();
      setEditingPolicy(null);
    } catch (err) {
      console.error('약관 저장 실패:', err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container>

      <Section>
        <SectionHeader>
          <SectionTitle>약관 관리</SectionTitle>
        </SectionHeader>
        <PolicyList>
          {POLICY_TYPES.map(p => (
            <PolicyRow key={p.id}>
              <PolicyInfo>
                <IoDocumentTextOutline size={18} color="#4A6741" />
                <PolicyLabel>{p.label}</PolicyLabel>
                {/* {policies[p.id] ? (
                  <PolicyStatus>등록됨</PolicyStatus>
                ) : (dkz
                  <PolicyStatus $empty>미등록</PolicyStatus>
                )} */}
              </PolicyInfo>
              <PolicyActions>
                {/* {!policies[p.id] && (
                  <PolicyBtn onClick={() => handleInitPolicy(p.id)}>초기 등록</PolicyBtn>
                )} */}
                <PolicyBtn $edit onClick={() => handleEditOpen(p)}>
                  <IoCreateOutline size={14} /> 수정
                </PolicyBtn>
              </PolicyActions>
            </PolicyRow>
          ))}
        </PolicyList>
      </Section>

      <Section>
        <SectionHeader>
          <SectionTitle>알림 설정</SectionTitle>
        </SectionHeader>
        <NotifList>
          {NOTIFICATION_ITEMS.map(n => (
            <NotifRow key={n.key}>
              <NotifInfo>
                <NotifLabelRow>
                  <NotifLabel>{n.label}</NotifLabel>
                  <TargetTags>
                    {n.targets.map(t => (
                      <TargetTag key={t} $admin={t === '관리자'}>{t}</TargetTag>
                    ))}
                  </TargetTags>
                </NotifLabelRow>
                <NotifDesc>{n.desc}</NotifDesc>
              </NotifInfo>
              <Toggle $on={notifSettings[n.key]} onClick={() => toggleNotification(n.key)}>
                <ToggleThumb $on={notifSettings[n.key]} />
              </Toggle>
            </NotifRow>
          ))}
        </NotifList>
      </Section>

      <Section>
        <SectionHeader>
          <SectionTitle>관리자 계정</SectionTitle>
        </SectionHeader>
        {adminUser ? (
          <>
            <AdminCard>
              <AdminInfo>
                <AdminAvatar>{adminUser.name?.charAt(0) || 'A'}</AdminAvatar>
                <AdminDetail>
                  <AdminName>{adminUser.name}</AdminName>
                  <AdminId>아이디: {adminUser.loginId}</AdminId>
                </AdminDetail>
                <RoleBadge $super>관리자</RoleBadge>
              </AdminInfo>
              <PwChangeBtn onClick={handlePwOpen}>
                <IoLockClosedOutline size={14} /> 비밀번호 변경
              </PwChangeBtn>
            </AdminCard>
            <AdminHint>관리자 계정으로 앱 로그인이 가능합니다</AdminHint>
          </>
        ) : (
          <AdminEmpty>관리자 계정을 불러오는 중...</AdminEmpty>
        )}
      </Section>

      <Section>
        <SectionHeader>
          <SectionTitle>회사 정보 (하단 표시)</SectionTitle>
        </SectionHeader>
        <CompanyForm>
          <CompanyRow>
            <CompanyLabel>헤더 표시명</CompanyLabel>
            <CompanyInput value={companyInfo.headerTitle} onChange={e => setCompanyInfo(p => ({ ...p, headerTitle: e.target.value }))} placeholder="조군산업" />
          </CompanyRow>
          <CompanyRow>
            <CompanyLabel>회사명</CompanyLabel>
            <CompanyInput value={companyInfo.name} onChange={e => setCompanyInfo(p => ({ ...p, name: e.target.value }))} placeholder="(주)조군산업 JOGUN INDUSTRY" />
          </CompanyRow>
          <CompanyRow>
            <CompanyLabel>대표자명</CompanyLabel>
            <CompanyInput value={companyInfo.ceo} onChange={e => setCompanyInfo(p => ({ ...p, ceo: e.target.value }))} placeholder="조군" />
          </CompanyRow>
          <CompanyRow>
            <CompanyLabel>사업자번호</CompanyLabel>
            <CompanyInput value={companyInfo.bizNo} onChange={e => setCompanyInfo(p => ({ ...p, bizNo: e.target.value }))} placeholder="000-00-00000" />
          </CompanyRow>
          <CompanyRow>
            <CompanyLabel>주소</CompanyLabel>
            <CompanyInput value={companyInfo.address} onChange={e => setCompanyInfo(p => ({ ...p, address: e.target.value }))} placeholder="인천광역시 서구 가좌동 524-11" />
          </CompanyRow>
          <CompanyRow>
            <CompanyLabel>대표번호</CompanyLabel>
            <CompanyInput value={companyInfo.phone} onChange={e => setCompanyInfo(p => ({ ...p, phone: e.target.value }))} placeholder="1544-5023" />
          </CompanyRow>
          <CompanySaveRow>
            {companySaved && <CompanySavedMsg>저장되었습니다</CompanySavedMsg>}
            <SaveBtn onClick={saveCompanyInfo} disabled={companySaving}>{companySaving ? '저장 중...' : '저장'}</SaveBtn>
          </CompanySaveRow>
        </CompanyForm>
      </Section>

      {showPwModal && (
        <Overlay onClick={() => setShowPwModal(false)}>
          <PwModal onClick={e => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>비밀번호 변경</ModalTitle>
              <CloseBtn onClick={() => setShowPwModal(false)}>&times;</CloseBtn>
            </ModalHeader>
            <ModalBody>
              {pwSuccess ? (
                <SuccessMsg><IoCheckmarkCircle size={40} color="#4A6741" /><span>비밀번호가 변경되었습니다</span></SuccessMsg>
              ) : (
                <>
                  <PwGroup>
                    <PwLabel>현재 비밀번호</PwLabel>
                    <PwInput type="password" value={pwForm.current} onChange={e => setPwForm({ ...pwForm, current: e.target.value })} placeholder="현재 비밀번호" />
                  </PwGroup>
                  <PwGroup>
                    <PwLabel>새 비밀번호</PwLabel>
                    <PwInput type="password" value={pwForm.newPw} onChange={e => setPwForm({ ...pwForm, newPw: e.target.value })} placeholder="새 비밀번호 (4자 이상)" />
                  </PwGroup>
                  <PwGroup>
                    <PwLabel>새 비밀번호 확인</PwLabel>
                    <PwInput type="password" value={pwForm.confirm} onChange={e => setPwForm({ ...pwForm, confirm: e.target.value })} placeholder="새 비밀번호 확인" />
                  </PwGroup>
                  {pwError && <PwError>{pwError}</PwError>}
                </>
              )}
            </ModalBody>
            {!pwSuccess && (
              <ModalFooter>
                <CancelBtn onClick={() => setShowPwModal(false)}>취소</CancelBtn>
                <SaveBtn onClick={handlePwSave} disabled={pwSaving}>{pwSaving ? '변경 중...' : '변경'}</SaveBtn>
              </ModalFooter>
            )}
          </PwModal>
        </Overlay>
      )}

      {editingPolicy && (
        <Overlay onClick={() => setEditingPolicy(null)}>
          <Modal onClick={e => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>{editingPolicy.label} 수정</ModalTitle>
              <CloseBtn onClick={() => setEditingPolicy(null)}>&times;</CloseBtn>
            </ModalHeader>
            <ModalBody>
              <EditTextarea
                value={editContent}
                onChange={e => setEditContent(e.target.value)}
                rows={20}
                placeholder="약관 내용을 입력하세요..."
              />
            </ModalBody>
            <ModalFooter>
              <CancelBtn onClick={() => setEditingPolicy(null)}>취소</CancelBtn>
              <SaveBtn onClick={handleSave} disabled={saving}>
                {saving ? '저장 중...' : '저장'}
              </SaveBtn>
            </ModalFooter>
          </Modal>
        </Overlay>
      )}
    </Container>
  );
};

export default AdminSettingsPage;

const Container = styled.div`padding: 32px;`;

const Section = styled.div`background: #fff; border-radius: 14px; padding: 24px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); margin-bottom: 24px;`;
const SectionHeader = styled.div`display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;`;
const SectionTitle = styled.h3`font-size: 16px; font-weight: 500; color: #1E2A32;`;

/* 약관 관리 */
const PolicyList = styled.div``;
const PolicyRow = styled.div`
  display: flex; justify-content: space-between; align-items: center;
  padding: 14px 0;
  &:not(:last-child) { border-bottom: 1px solid #F0F0EC; }
`;
const PolicyInfo = styled.div`display: flex; align-items: center; gap: 10px;`;
const PolicyLabel = styled.span`font-size: 14px; font-weight: 400; color: #1E2A32;`;
const PolicyStatus = styled.span`
  font-size: 11px; padding: 2px 8px; border-radius: 6px;
  background: ${p => p.$empty ? '#F5F5F0' : '#EDF2EB'};
  color: ${p => p.$empty ? '#8C9AA4' : '#4A6741'};
`;
const PolicyActions = styled.div`display: flex; gap: 8px;`;
const PolicyBtn = styled.button`
  display: flex; align-items: center; gap: 4px;
  padding: 6px 12px; border-radius: 8px; font-size: 12px; font-weight: 500;
  background: ${p => p.$edit ? '#EDF2EB' : '#F5F5F0'};
  color: ${p => p.$edit ? '#4A6741' : '#5A6B75'};
  &:hover { opacity: 0.8; }
`;

/* 알림 */
const NotifList = styled.div``;
const NotifRow = styled.div`display: flex; justify-content: space-between; align-items: center; padding: 14px 0; &:not(:last-child) { border-bottom: 1px solid #F0F0EC; }`;
const NotifInfo = styled.div`flex: 1;`;
const NotifLabelRow = styled.div`display: flex; align-items: center; gap: 8px;`;
const NotifLabel = styled.div`font-size: 14px; font-weight: 400; color: #1E2A32;`;
const TargetTags = styled.div`display: flex; gap: 4px;`;
const TargetTag = styled.span`
  font-size: 11px; padding: 1px 8px; border-radius: 6px; font-weight: 400;
  background: ${p => p.$admin ? '#EDF2EB' : '#FFF0ED'};
  color: ${p => p.$admin ? '#4A6741' : '#E85830'};
`;
const NotifDesc = styled.div`font-size: 12px; color: #8C9AA4; margin-top: 2px;`;
const Toggle = styled.div`
  width: 44px; height: 24px; border-radius: 12px; cursor: pointer; position: relative;
  background: ${p => p.$on ? '#4A6741' : '#D9DDD6'}; transition: background 0.2s;
`;
const ToggleThumb = styled.div`
  width: 20px; height: 20px; border-radius: 50%; background: #fff; position: absolute; top: 2px;
  left: ${p => p.$on ? '22px' : '2px'}; transition: left 0.2s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.15);
`;

/* 관리자 계정 */
const AdminCard = styled.div`
  display: flex; justify-content: space-between; align-items: center;
  padding: 16px; background: #FAFAF7; border-radius: 12px;
`;
const AdminInfo = styled.div`display: flex; align-items: center; gap: 14px;`;
const AdminAvatar = styled.div`
  width: 44px; height: 44px; border-radius: 50%; background: #4A6741; color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; font-weight: 500;
`;
const AdminDetail = styled.div``;
const AdminName = styled.div`font-size: 15px; font-weight: 500; color: #1E2A32;`;
const AdminId = styled.div`font-size: 13px; color: #8C9AA4; margin-top: 2px;`;
const AdminEmpty = styled.div`font-size: 14px; color: #8C9AA4; text-align: center; padding: 20px;`;
const AdminHint = styled.div`font-size: 12px; color: #8C9AA4; margin-top: 10px; text-align: center;`;
const RoleBadge = styled.span`
  font-size: 11px; padding: 3px 10px; border-radius: 10px; font-weight: 400;
  background: ${p => p.$super ? '#4A6741' : '#EDF2EB'};
  color: ${p => p.$super ? '#fff' : '#4A6741'};
`;
/* 회사 정보 */
const CompanyForm = styled.div`display: flex; flex-direction: column; gap: 14px;`;
const CompanyRow = styled.div`display: flex; align-items: center; gap: 12px;`;
const CompanyLabel = styled.label`font-size: 13px; font-weight: 400; color: #5A6B75; min-width: 70px; flex-shrink: 0;`;
const CompanyInput = styled.input`
  flex: 1; padding: 10px 14px; border: 1px solid #E0E0E0; border-radius: 10px;
  font-size: 14px; color: #1E2A32;
  &:focus { border-color: #4A6741; outline: none; }
`;
const CompanySaveRow = styled.div`display: flex; justify-content: flex-end; align-items: center; gap: 12px; margin-top: 4px;`;
const CompanySavedMsg = styled.span`font-size: 13px; color: #4A6741;`;

const PwChangeBtn = styled.button`
  display: flex; align-items: center; gap: 6px;
  padding: 8px 16px; border-radius: 10px; font-size: 13px; font-weight: 400;
  background: #fff; color: #5A6B75; border: 1px solid #E0E0E0;
  &:hover { background: #F5F5F0; }
`;

/* 비밀번호 모달 */
const PwModal = styled.div`background: #fff; border-radius: 16px; width: 400px;`;
const PwGroup = styled.div`margin-bottom: 16px;`;
const PwLabel = styled.label`display: block; font-size: 13px; font-weight: 400; color: #1E2A32; margin-bottom: 6px;`;
const PwInput = styled.input`
  width: 100%; padding: 10px 14px; border: 1px solid #E0E0E0; border-radius: 10px;
  font-size: 14px; color: #1E2A32;
  &:focus { border-color: #4A6741; outline: none; }
`;
const PwError = styled.div`font-size: 13px; color: #C0392B; margin-top: 4px;`;
const SuccessMsg = styled.div`
  display: flex; flex-direction: column; align-items: center; gap: 12px;
  padding: 32px 0; font-size: 15px; color: #1E2A32;
`;

/* 모달 */
const Overlay = styled.div`
  position: fixed; inset: 0; background: rgba(0,0,0,0.4); z-index: 1000;
  display: flex; align-items: center; justify-content: center;
`;
const Modal = styled.div`
  background: #fff; border-radius: 16px; width: 700px; max-height: 80vh;
  display: flex; flex-direction: column;
`;
const ModalHeader = styled.div`
  display: flex; justify-content: space-between; align-items: center;
  padding: 20px 24px; border-bottom: 1px solid #F0F0EC;
`;
const ModalTitle = styled.h3`font-size: 18px; font-weight: 500; color: #1E2A32;`;
const CloseBtn = styled.button`font-size: 24px; color: #8C9AA4; line-height: 1; &:hover { color: #333; }`;
const ModalBody = styled.div`padding: 20px 24px; flex: 1; overflow-y: auto;`;
const EditTextarea = styled.textarea`
  width: 100%; padding: 16px; border: 1px solid #E0E0E0; border-radius: 10px;
  font-size: 14px; line-height: 1.7; color: #1E2A32; font-family: inherit;
  resize: vertical; min-height: 400px;
  &:focus { border-color: #4A6741; outline: none; }
`;
const ModalFooter = styled.div`
  display: flex; justify-content: flex-end; gap: 10px;
  padding: 16px 24px; border-top: 1px solid #F0F0EC;
`;
const CancelBtn = styled.button`padding: 10px 20px; border-radius: 10px; font-size: 14px; background: #F5F5F0; color: #5A6B75;`;
const SaveBtn = styled.button`
  padding: 10px 20px; border-radius: 10px; font-size: 14px; font-weight: 500;
  background: #4A6741; color: #fff;
  &:hover { background: #3B5534; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;
